import { render, staticRenderFns } from "./_category.vue?vue&type=template&id=0e4c314a&scoped=true"
import script from "./_category.vue?vue&type=script&lang=js"
export * from "./_category.vue?vue&type=script&lang=js"
import style0 from "./_category.vue?vue&type=style&index=0&id=0e4c314a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4c314a",
  null
  
)

/* custom blocks */
import block0 from "./_category.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports